<template>
  <div>
    <component
      :is="filter.component"
      v-for="(filter,i) in filtersWithComponents"
      :key="i"
      class="mb-4 mx-1"
      v-bind="filter"
      :value="values[filter.dataKey]"
      :tooltip="filter.tooltipEnabled ? filter.tooltip : ''"
      @input="update(filter,$event)"
    />
  </div>
</template>

<script>
import FilterSearchSelect from '~contemporaryTheme/components/Base/FilterSearchSelect'
import FilterListSelect from '~contemporaryTheme/components/Base/FilterListSelect'
import FilterSwitch from '~contemporaryTheme/components/Base/FilterSwitch'
import FilterBoolean from '~contemporaryTheme/components/Base/FilterBoolean'
import FilterInput from '~contemporaryTheme/components/Base/FilterInput'
import FilterCheckboxes from '~contemporaryTheme/components/Base/FilterCheckboxes'

export default {
  props: {
    values: {
      type: Object,
      default: () => ({}),
    },
    filters: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    filtersWithComponents() {
      return this.filters.map((filter) => {
        switch (filter.type) {
          case 'boolean':
            return { ...filter, component: FilterBoolean }
          case 'yesNo':
            return { ...filter, component: FilterSwitch }
          case 'listSelect': // probably no longer used
            return { ...filter, component: FilterListSelect }
          case 'select':
          case 'searchSelect':
            return { ...filter, component: FilterSearchSelect }
          case 'multiselect':
            return { ...filter, component: FilterSearchSelect, multiple: true }
          case 'checkbox':
            return { ...filter, component: FilterCheckboxes }
          case 'radio':
            return {
              ...filter,
              component: FilterCheckboxes,
              singular: true,
            }
          default:
            return { ...filter, component: FilterInput }
        }
      })
    },
  },
  methods: {
    update(filter, value) {
      this.$emit('input', { ...this.values, [filter.dataKey]: value })
    },
  },
}
</script>
